import { Styles } from '#~/agent/components/index.js';
import { Summary } from './summary/index.js';
import type { PanelProps } from './types.js';
import { useWiring } from './wiring.js';
import { Icon } from '@studio/design-system/icon';
import { vendorName } from '@studio/design-system/themes/vendor.js';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';

/** `<Panel>` component. */
export const Panel = ({ agentIds, roomId, ...props }: PanelProps): ReactElement => {
  const wiring = useWiring(agentIds, roomId);

  const agents = Object.values(wiring.agents);

  const allOffline = agents.every((agent) => agent.status === 'offline');

  const style = Styles.status[agents[0]?.status ?? 'offline'];

  if (agents.length === 0 || !agents[0]?.id) {
    return (
      <div {...props}>
        <div className={twMerge('flex max-h-[75vh] flex-col gap-16 overflow-y-auto')} />
      </div>
    );
  }

  return (
    <div {...props}>
      <div
        className={twMerge(
          'flex max-h-[75vh] flex-col gap-16 overflow-y-auto border-b border-base-50 p-16'
        )}
      >
        <Summary roomId={roomId} wiring={wiring} />
        {!!allOffline && (
          <div className={twMerge('flex items-center gap-8 rounded border p-6', style.border)}>
            <div>
              <Icon className={twMerge('text-xl', style.text)} icon='alert-triangle' />
            </div>

            <p className='grow'>
              {vendorName()} is unable to connect to your agent. Please check your internet
              connection or restart the {vendorName()} Bridge.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
